/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { toHeaderCase } from 'js-convert-case';
import config from "../config/portfolio.template.form.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import previewConfig from "../config/timelineSteps.config.json";
import { useCollection } from "../provider";
import { GET_PORTFOLIO_CREDENTIAL_SCHEMA } from "../graphql";

export interface IPortfolioFormMethods extends IPluginMethodMap {
    getPortfolioFormProps(args: any): Promise<any>;
}

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class PortfolioFormService implements IAgentPlugin {
    readonly methods: IPortfolioFormMethods;

    constructor() {
        this.methods = {
            getPortfolioFormProps: this.getProps.bind(this),
        };
    }

    async getProps(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        const { portfolioTempId } = useCollection();
        try {
            if (client) {
                const res = await client.query({
                    query: GET_PORTFOLIO_CREDENTIAL_SCHEMA,
                    variables: {
                        input: {
                            criteria: {
                                group: portfolioTempId
                            },
                            offset: args?.offset ?? 0,
                            size: args?.size ?? 10
                        },
                        "tree": "PORTFOLIO_TEMPLATE",
                        nodeInput: {
                            filter: {
                                parent: null,
                            },
                            offset: args?.offset ?? 0,
                            size: args?.size ?? 10,
                        }
                    },
                    fetchPolicy: "network-only",
                });
                if (res?.data) {
                    console.log(`portfolio data`, res?.data);
                    return {
                        portfolio:this.getPortfolioData(res?.data?.getListOfNode?.data),
                        templatesCount: res?.data?.getListOfCredentialSchema?.data?.length,
                        templates: this.getTemplateForm(res?.data?.getListOfCredentialSchema?.data),
                        steps: this.getSteps(res?.data?.getListOfCredentialSchema?.data)
                    }
                }
            }

        } catch (err: any) {
            return err;
        }
    }

    private getSteps(data: any) {
        let steps: any = [];
        if (Array.isArray(data) && data?.length > 0) {
            data.forEach(element => {
                steps.push({ label: element?.name })
            });
            steps.push(previewConfig?.preview);
        }
        return steps;
    }

    private getTemplateForm(data: any) {
        let formData: any = [];
        if (Array.isArray(data) && data?.length > 0) {
            data.forEach(element => {
                formData.push({
                    credentialLogo: element?.logo,
                    credentialId: element?.id,
                    credentialDescription: element?.description,
                    credentialFields: element?.jsonFormat?.credential,
                    submitButtonLabel: config?.submitButtonTitle,
                    credentialName: this.formatName(
                        element?.name
                    ),
                })
            });
        }
        return formData;
    }

    private formatName(name: string) {
        if (name) {
            return toHeaderCase(name);
        }
    }

    private getPortfolioData(data:any){
        const { portfolioTempId } = useCollection();
        let _portfolio = data?.find(key=> key?.uuid === portfolioTempId);
        if(_portfolio){
            return {
                logoSrc: _portfolio?.logo,
                title: toHeaderCase(_portfolio?.name),
                subtitle:_portfolio?.description
            }
        }
    }
}